<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex>
                <eqt-table
                        @refresh="getItems"
                        hide-actions
                        :total="total"
                        :loading="loading"
                        :title="$t('Pages.Users.export')"
                        :subtitle="$t('Pages.Users.export_subtitle')"
                        :items="items"
                        :headers="headers">
                    <template slot="filters">
                        <v-flex lg3>
                            <v-select
                                    :items="sectors"
                                    v-model="sector"
                                    :error-messages="errors.first('sector')"
                                    :label="$t('Pages.Sectors.title')"
                                    required
                                    name="sector"
                                    color="indigo"
                                    clearable
                                    multiple
                                    item-text="name"
                                    item-value="id"
                            ></v-select>
                        </v-flex>
                        <v-flex lg3>
                            <v-tooltip top>
                                <v-btn slot="activator" absolute right small fab dark color="indigo dark1" @click="download">
                                    <v-icon dark>mdi-download</v-icon>
                                </v-btn>
                                <span>{{$t('Core.Fields.download')}}</span>
                            </v-tooltip>
                        </v-flex>
                    </template>
                    <template slot="add">
                        <slot name="add"></slot>
                    </template>
                    <template slot="items" slot-scope="{ item }">
                        <td>{{ item.id }}</td>
                        <td class="text-xs-center">
                            <v-avatar slot="activator" size="30px">
                                <img :src="item.profile.avatar" :alt="item.profile.name">
                            </v-avatar>
                        </td>
                        <td>{{ item.profile.name }}</td>
                        <td>{{ item.email}}</td>
                        <td>{{ item.jmbg}}</td>
                        <td>{{item.sectors ?  item.sectors.map(function(item) {
                            return item['name'];
                            }) : $t('Common.not_assigned')}}</td>
                        <td class="text-xs-center">{{ item.remainingVacation.previous}}</td>
                        <td class="text-xs-center">{{ item.remainingVacation.current}}</td>
                        <td>{{ item.profile.is_agency ? $t('Common.yes') :  $t('Common.no')}}</td>
                        <slot name="items" :item="item"></slot>
                    </template>
                </eqt-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EqtTable from '../components/core/Table'
    import i18n from '@/i18n'
    export default {
        name: "Export",
        components: {EqtTable},
        props: {

        },
        data() {
            let result = {
                sectors: [],
                sector: null,
                items: [],
                initial: true,
                loading: false,
                total: 0,
                pagination: {},
                headers: [
                    {
                        sortable: true,
                        text: '#',
                        value: 'id'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.avatar'),
                        value: 'profile.avatar',
                        align: 'center'
                    },
                    {
                        sortable: true,
                        text: i18n.t('Pages.Users.model.name'),
                        value: 'profile.name'
                    },
                    {
                        sortable: true,
                        text: i18n.t('Pages.Users.model.email'),
                        value: 'email'
                    },
                    {
                        sortable: true,
                        text: i18n.t('Pages.Users.model.jmbg'),
                        value: 'jmbg'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Sectors.title'),
                        value: 'sectors'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.prev_year'),
                        value: 'previous',
                        align: 'center'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.current_year'),
                        value: 'current',
                        align: 'center'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.agency'),
                        value: 'profile.is_agency'
                    }
                ]
            };

            return result;

        },
        computed:{

        },
        created () {
            this.getSectors();
        },
        methods: {
            getSectors(){
                this.repositories.sector.all().then((response) => {
                    this.sectors = response.data.data;
                });
            },
            download(){
                this.loading = true;
                let data = {
                    q: this.pagination.q,
                    sector: this.sector,
                    orderBy: this.pagination.orderBy
                };


                this.repositories.user.searchBySectorAndDownload(data, this.$t('Pages.Users.remaining_vacation') + new Date().toLocaleDateString('fr')).then(response => {

                }).finally(() => {
                    this.loading = this.initial = false;
                    this.setFetching(false);
                });
            },
            getItems(data = null){
                if(data) {
                    this.pagination = data;
                }
                else{
                    data = this.pagination;
                }

                data.sector = this.sector;
                data.include = 'sectors,remainingVacation';
                if(this.initial){
                    this.setFetching(true);
                }
                this.loading = true;
                this.repositories.user.searchBySector(data).then(response => {
                    this.items = response.data.data;
                    this.total = response.data.meta.pagination.total;
                }).finally(() => {
                    this.loading = this.initial = false;
                    this.setFetching(false);
                });
            },
            deleteItem(item){
                this.repositories.user.delete(item.id).then((response) => {
                    this.$toast.info(response.data.message);
                    this.getItems(this.pagination);
                })
            }
        },
        watch: {
            'sector': function(){
                this.getItems();
            },
        }
    }
</script>

<style scoped>

</style>
